var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33824 5C1.33824 2.56345 3.31345 0.588235 5.75 0.588235C8.18655 0.588235 10.1618 2.56345 10.1618 5C10.1618 7.43655 8.18655 9.41177 5.75 9.41177C3.31345 9.41177 1.33824 7.43655 1.33824 5ZM5.75 0C2.98858 0 0.75 2.23858 0.75 5C0.75 7.76142 2.98858 10 5.75 10C8.51142 10 10.75 7.76142 10.75 5C10.75 2.23858 8.51142 0 5.75 0ZM5.75 2.1875C5.75 2.01491 5.61009 1.875 5.4375 1.875C5.26491 1.875 5.125 2.01491 5.125 2.1875V5C5.125 5.11837 5.19188 5.22657 5.29775 5.27951L7.17275 6.21701C7.32711 6.29419 7.51482 6.23162 7.59201 6.07725C7.66919 5.92289 7.60662 5.73518 7.45225 5.65799L5.75 4.80686V2.1875Z",
    fill: "#999CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0ae0346d591e7df7a7a79303568de647.svg";
export { ForwardRef as ReactComponent };